import styled from 'styled-components';
import { motion } from 'framer-motion6';
import { sizes } from 'style';

export const TeamWrapper = styled(motion.div)`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;

  @media ${sizes.tabletLandscape} {
    margin-top: 60px;
    flex-direction: row;
  }
`;

export const ValueProposition = styled.div`
  > h3 {
    margin: 14px 0 14px 0;
    font-size: 20px;
    line-height: 24px;
  }

  > p {
    margin: 0;
    line-height: 24px;
  }
`;

export const ValuePropositions = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  margin-top: 28px;

  > div {
    > ${ValueProposition} {
      margin-bottom: 32px;
    }
  }

  @media ${sizes.tabletLandscape} {
    height: 100%;
    padding: 100px 4%;
    justify-content: space-between;
    flex-direction: row;

    > div {
      max-width: 320px;

      :first-of-type {
        > ${ValueProposition}:first-of-type {
          margin-bottom: 60px;
        }
      }

      :last-of-type {
        > ${ValueProposition}:first-of-type {
          margin-bottom: 34px;
        }
      }
    }
  }

  @media ${sizes.mediumLargeDesktop} {
    padding: 0 7%;
    padding-top: 100px;
  }
`;
